"use strict";

var BlsComparePageShopify = (function () {
  return {
    initCompareItems: function () {
      this.init();
    },

    init: function () {
      let compare_items;
      try {
        compare_items = JSON.parse(
          localStorage.getItem("mm__compare-items")
        );
      } catch (e) {
        compare_items = null;
        localStorage.removeItem("mm__compare-items");
      }
      const compareDiv = document.querySelector(".compare-page-main");
      if (!compareDiv) return;
      const div_no_product = compareDiv.querySelector(".compare-no-product-js");
      if (!div_no_product) return;
      if (compare_items === null || compare_items.length === 0) {
        div_no_product.classList.remove("hidden");
        document.dispatchEvent(
          new CustomEvent("theme:compare-updated", {
            detail: { count: 0 },
          })
        );
        window.themeHeaderCounters?.refreshCompare?.();
      } else {
        const query = this.buildSearchQuery(compare_items);
        if (!query) {
          div_no_product.classList.remove("hidden");
          return;
        }
        const compareSection = document.querySelector(".compare-page-section");
        const dynamicSectionId = compareSection?.dataset.sectionId || "";
        const sectionIds = ["page-compare", dynamicSectionId, "main"].filter(
          (value, index, self) => Boolean(value) && self.indexOf(value) === index
        );

        const fetchCompareRows = (sectionIndex) => {
          const sectionId = sectionIds[sectionIndex];
          const productAjaxURL =
            "?section_id=" +
            sectionId +
            "&type=product&options[unavailable_products]=last&q=" +
            encodeURIComponent(query);
          return fetch(`${window.routes.search_url}${productAjaxURL}`)
            .then((response) => response.text())
            .then((responseText) => {
              const html = new DOMParser().parseFromString(
                responseText,
                "text/html"
              );
              const rows = html.querySelectorAll(
                ".compare-page-section > .product-compare, .compare-page-section .product-compare"
              );
              if (rows.length === 0 && sectionIndex + 1 < sectionIds.length) {
                return fetchCompareRows(sectionIndex + 1);
              }
              return rows;
            });
        };

        fetchCompareRows(0)
          .then((bpc) => {
            const table = compareDiv.querySelector(".compare-table");
            if (compare_items.length !== 0) {
              const basic = compareDiv.querySelector(".compare-row-basic");
              const vendor = compareDiv.querySelector(".compare-row-vendor");
              const availability = compareDiv.querySelector(
                ".compare-row-availability"
              );
              const size = compareDiv.querySelector(".compare-row-size");
              const color = compareDiv.querySelector(".compare-row-color");
              const review = compareDiv.querySelector(".compare-row-review");
              if (
                !basic ||
                !vendor ||
                !availability ||
                !size ||
                !color ||
                !review
              ) {
                div_no_product.classList.remove("hidden");
                return;
              }
              if (bpc.length > 0) {
                if (table) {
                  table.classList.remove("hidden");
                  const exist_items = table.querySelectorAll(".compare-value");
                  if (exist_items.length !== 0) {
                    exist_items.forEach((ei) => {
                      ei.remove();
                    });
                  }
                }
                bpc.forEach((el) => {
                  basic.innerHTML +=
                    el.querySelector(".compare-row-basic").innerHTML;
                  vendor.innerHTML += el.querySelector(
                    ".compare-row-vendor"
                  ).innerHTML;
                  availability.innerHTML += el.querySelector(
                    ".compare-row-availability"
                  ).innerHTML;
                  size.innerHTML +=
                    el.querySelector(".compare-row-size").innerHTML;
                  color.innerHTML +=
                    el.querySelector(".compare-row-color").innerHTML;
                  review.innerHTML += el.querySelector(
                    ".compare-row-review"
                  ).innerHTML;
                });
                this.renderMetafieldRows(compareDiv, bpc);
                this.scanDynamicModules(compareDiv);
                initLazyloadItem();
                document.dispatchEvent(
                  new CustomEvent("theme:compare-updated", {
                    detail: { count: compare_items.length },
                  })
                );
                window.themeHeaderCounters?.refreshCompare?.();
              } else {
                div_no_product.classList.remove("hidden");
              }
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally((e) => {});
      }
    },
    scanDynamicModules: function (container) {
      if (!container) return;
      if (window.theme?.scanModules) {
        window.theme.scanModules(container);
        return;
      }
      document.dispatchEvent(
        new CustomEvent("theme:dom-updated", {
          detail: { container },
        })
      );
    },
    renderMetafieldRows: function (compareDiv, productsRows) {
      const table = compareDiv?.querySelector(".compare-table");
      const anchor = table?.querySelector(".compare-metafields-anchor");
      if (!table || !anchor) return;
      const normalizedRows = Array.from(productsRows || []);
      if (normalizedRows.length === 0) return;

      table.querySelectorAll(".compare-row-metafield-js").forEach((row) => {
        row.remove();
      });

      const orderedKeys = [];
      const labels = {};
      const productMetafields = normalizedRows.map((row) => {
        const values = {};
        row.querySelectorAll(".compare-meta-entry[data-mf-key]").forEach((entry) => {
          const key = (entry.dataset.mfKey || "").trim();
          if (!key) return;
          if (!orderedKeys.includes(key)) {
            orderedKeys.push(key);
          }
          if (!labels[key]) {
            labels[key] = (entry.dataset.mfLabel || key).trim();
          }
          const value = (entry.dataset.mfValue || "").trim();
          values[key] = value || "-";
        });
        return values;
      });

      let differentRowIndex = 0;
      orderedKeys.forEach((key) => {
        const rowValues = productMetafields.map((values) => values[key] || "-");
        if (rowValues.every((value) => value === "-" || value === "")) return;

        const row = document.createElement("div");
        row.className = "compare-row flex flex-nowrap compare-row-metafield-js";
        row.setAttribute("data-mf-key", key);

        if (this.hasDifferentValues(rowValues)) {
          row.classList.add("compare-row--different");
          row.classList.add(
            differentRowIndex % 2 === 0
              ? "compare-row--different-a"
              : "compare-row--different-b"
          );
          differentRowIndex += 1;
        }

        const fieldCell = document.createElement("div");
        fieldCell.className =
          "compare-field lh-normal flex align-center heading-style border-inline-end px-20 py-15 border-bottom";
        fieldCell.textContent = labels[key] || key;
        row.appendChild(fieldCell);

        rowValues.forEach((value) => {
          const valueCell = document.createElement("div");
          valueCell.className =
            "compare-value word-break flex-wrap border-inline-end px-20 py-15 border-bottom flex align-center";
          valueCell.textContent = value || "-";
          row.appendChild(valueCell);
        });

        table.insertBefore(row, anchor);
      });
    },
    hasDifferentValues: function (values) {
      const normalized = values.map((value) => this.normalizeCompareValue(value));
      return new Set(normalized).size > 1;
    },
    normalizeCompareValue: function (value) {
      return String(value || "-")
        .replace(/\s+/g, " ")
        .trim()
        .toLowerCase();
    },
    buildSearchQuery: function (items) {
      if (!Array.isArray(items) || items.length === 0) return "";
      const tokens = items
        .map((item) => {
          const value = String(item || "").trim();
          if (!value) return "";
          if (/^\d+$/.test(value)) return `id:${value}`;
          return `handle:${value}`;
        })
        .filter(Boolean);
      return tokens.join(" OR ");
    },
  };
})();
BlsComparePageShopify.initCompareItems();

class CompareRemove extends HTMLElement {
  constructor() {
    super();
    this.productId = this.dataset.productId;
    this.productHandle = this.dataset.productHandle;
    this.init();
  }
  init() {
    this.addEventListener("click", this.onThisClick.bind(this));
  }
  onThisClick() {
    const localListProductIds = localStorage.getItem("mm__compare-items");
    const allThisProductIds = document.querySelectorAll(
      `compare-remove[data-product-id="${this.productId}"]`
    );
    let listProductIds = [];
    const storageKey = this.productHandle || this.productId;
    if (!storageKey) return;
    if (localListProductIds && allThisProductIds.length > 0) {
      // compare localstorage exists
      let parseLocalListProductIds;
      try {
        parseLocalListProductIds = JSON.parse(localListProductIds);
      } catch (e) {
        parseLocalListProductIds = [];
        localStorage.removeItem("mm__compare-items");
      }
      const filteredList = parseLocalListProductIds.filter(
        (item) => item !== storageKey && item !== this.productId
      );
      listProductIds.push(...filteredList);
      const product_remove = document.querySelectorAll(
        `[data-product-handle="${this.productHandle}"]`
      );
      product_remove.forEach((e) => {
        e.remove();
      });
      if (JSON.parse(localListProductIds).length == 1) {
        const compareDiv = document.querySelector(".compare-page-main");
        if (!compareDiv) return;
        const div_no_product = compareDiv.querySelector(".compare-no-product-js");
        const compare_table = compareDiv.querySelector(".compare-table");
        div_no_product.classList.remove("hidden");
        compare_table?.remove();
      }
    }
    const stringifyListProductIds = JSON.stringify(listProductIds);
    localStorage.setItem("mm__compare-items", stringifyListProductIds);
    document.dispatchEvent(
      new CustomEvent("theme:compare-updated", {
        detail: { items: listProductIds, count: listProductIds.length },
      })
    );
    window.themeHeaderCounters?.refreshCompare?.();
  }
}
customElements.define("compare-remove", CompareRemove);
